import { useEffect, useState } from "react"
import { Container, Paper, Box, Button, Stack } from "@mui/material"
import Title from "../../../TitleUploaded"
import { UrlApi } from "../../../../services/apirest";
import { getData } from "../../../../services/library";
import { ApiServices, handleOnChangeTotal, formatNumber } from "../ApiServices";
import FormComprobanteEditar from "./FormComprobanteEditar";
import DialogoNuevoProveedor from "../altacomprobantes/DialogoNuevoProveedor";
import { Save } from "@mui/icons-material";
import { AdjuntoField, AdjuntoFileCard } from "../../../Form/AdjuntoField";
import { DownloadFiles, ViewUploadFile } from "../../../../services/DownloadFiles";
import moment from "moment";
import { armarNroComprobante, esComprobanteBanco } from "../functions";

export default function EditarComprobante(props) {
    const [datos, setDatos] = useState(props.datos);
    const [tiposComprobantes, settiposComprobantes] = useState([]);
    const [impuestos, setImpuestos] = useState([])
    const [proveedores, setProveedores] = useState([]);
    const [imputaciones, setImputaciones] = useState([]);
    const [imputacionesProveedor, setimputacionProveedor] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [condicionesPago, setcondicionesPago] = useState([]);
    const [valorPorcentajes, setvalorPorcentajes] = useState([]);
    const [tipoMoneda, settipoMoneda] = useState([]);
    const [proveedorSelected, setproveedorSelected] = useState(null);
    const [guardarImputacProveedor, setGuardarImputacProveedor] = useState(false); //le voy a indicar al backend si debe guardar la inputacion en caso de que no la tenga
    const [comprobanteSelected, setcomprobanteSelected] = useState("");
    const [total, setTotal] = useState();
    const [archivos, setArchivos] = useState([]);
    const [cargandoAdjunto, setCargandoAdjunto] = useState(false);
    const [errorAdjunto, setErrorAdjunto] = useState("");
    const [ocsSelected, setOcsSelected] = useState([]);
    const [totalMuestro, setTotalMuestro] = useState();
    const [calcularSubtotalIva, setCalcularSubtotalIva] = useState(true);
    const [neto, setnetoGravado] = useState();
    const [comprobanteExiste, setcomprobanteExiste] = useState([]);
    const [saldonoaplic, setsaldonoaplic] = useState();
    const [montoMaximoSinOC, setMontoMaximoSinOC] = useState();
    const [showAddProveedor, setShowAddProveedor] = useState(false);
    const [muestroDiferencia, setmuestroDiferencia] = useState();
    const [saldoNegativo, setSaldoNegativo] = useState();
    const [bancos, setBancos] = useState([]);
    const [showInfoDialog, setShowInfoDialog] = useState({ open: false, title: "Importante", message: "", buttonLabel: "Aceptar", onClose: () => setShowInfoDialog({ open: false }) });
    //Estados que manejan componentes visuales
    const [loading, setLoading] = useState(false);
    const [disbtn, setdisbtn] = useState(false);
    const [datosCuerpo, setdatosCuerpo] = useState([]);
    const [datosImpuestos, setDatosImpuestos] = useState([]); // Solo impuestos
    const [datosPie, setdatosPie] = useState([]);
    const [otrostributos, setotrosTributos] = useState();
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    const handleAddProveedor = () => {
        setShowAddProveedor(true);
    };

    const handleCloseAddProveedor = async (idNuevoProveedor) => {
        setShowAddProveedor(false)
        if (!!idNuevoProveedor) {
            await fetch(`${UrlApi}/proveedores/byid/${idNuevoProveedor}`)
                .then((data) => data.json())
                .then((data) => setproveedorSelected(data[0]))
        }
        getData("/imputacion_gastos", setImputaciones);
    };

    const handleCloseNotificacion = () => {
        setNotificacion({ ...notificacion, open: false });
    };

    const validarFormulario = () => {
        const errors = [];
        if (!proveedorSelected)
            errors.push("Es necesario seleccionar un proveedor.");
        if (!comprobanteSelected)
            errors.push("Es necesario seleccionar un comprobante");
        if (!datos.id_condicionpago)
            errors.push("Es necesario seleccionar una condición de venta");
        // if (!datos.id_imputacion)
        //   errors.push("Es necesario seleccionar una imputación");
        if (!datos.id_sucursal)
            errors.push("Es necesario seleccionar una sucursal");

        const esBanco = esComprobanteBanco(comprobanteSelected);

        if (esBanco) {
            if (!datos.id_banco)
                errors.push("Es necesario seleccionar un banco");
            if (!datos.concepto?.trim())
                errors.push("Es necesario ingresar el concepto del movimiento bancario");
        } else {
            if (!datos.comprobante_pv)
                errors.push("Es necesario ingresar el punto de venta del comprobante");
        }

        if (!datos.comprobante_nro)
            errors.push("Es necesario ingresar el numero del comprobante");
        if (!total)
            errors.push("Es necesario ingresar el importe TOTAL del comprobante");
        if (!esBanco && !datos.fecha_factura)
            errors.push("Es necesario seleccionar una fecha de comprobante");
        if (datos.id_tipomoneda !== 83 && !datos.tipo_cambio)
            errors.push("Es necesario ingresar un tipo de cambio");


        // if (!periodoSelected) errors.push("Es necesario seleccionar un periodo contable.");
        // Validaciones del cuerpo (dinámico)
        datosCuerpo.forEach((item, index) => {
            if (!item.subtotal)
                errors.push(`Fila ${index + 1}: Es necesario ingresar un importe neto en la linea.`);
            if (!item.subtotal_iva)
                errors.push(
                    `Fila ${index + 1}: Es necesario ingresar el subtotal CON IVA`
                );
            if (!item.id_porcentajeiva)
                errors.push(
                    `Fila ${index + 1}: Es necesario seleccionar un porcentaje de IVA`
                );
            if (!item.detalle_productos)
                errors.push(
                    `Fila ${index + 1}: Es necesario ingresar una descripcion en el de producto`
                );
        });

        // Validaciones del cuerpo (dinámico)
        datosImpuestos.forEach((item, index) => {
            // if (!item.detalle && !!item.importe)
            //   errors.push(`Fila ${index + 1}: Es necesario detallar el impuesto.`);
            if (!item.importe && !!item.detalle)
                errors.push(
                    `Fila ${index + 1}: Es necesario ingresar el importe del impuesto`
                );
        });

        if (errors.length) {
            setNotificacion({
                open: true,
                mensaje: errors[0],
                severity: "error",
                color: "#FADBD8",
            });
            return false;
        }
        return true;
    };

    //de entreada necesito obtener todas estas cosas
    useEffect(() => {
        ApiServices.getSucursales(setSucursales);
        ApiServices.getImpuestos(setImpuestos);
        ApiServices.getValorPorcentajes(setvalorPorcentajes);
        ApiServices.getCondicionesPago(setcondicionesPago);
        ApiServices.getTipoMonedas(settipoMoneda);
        ApiServices.getMaximoFactura(setMontoMaximoSinOC);
        ApiServices.getImputaciones(setImputaciones);
        getData("/bancos", setBancos);

    }, []);


    useEffect(() => {
        const obtenerCoincidencias = async () => {
            if (datos?.cuit_proveedor) {
                // Buscamos solo el dato de este CUIT

                const prov = await ApiServices.getProveedorByCuit(datos.cuit_proveedor);

                if (prov) {
                    setproveedorSelected(prov);
                    setProveedores([prov]);
                }
            }
        };
        obtenerCoincidencias();
    }, []);

    const getArchivos = () => {
        fetch(UrlApi + "/uploadfiles/todownload/" + datos.uuid_comprobante)
            .then((res) => res.json())
            .then((data) => setArchivos(Array.isArray(data) ? data : []))
            .catch(() => setArchivos([]));
    };

    useEffect(() => {
        if (datos.uuid_comprobante) getArchivos();
    }, [datos.uuid_comprobante]);

    const handleAdjuntoChange = async (e) => {
        const file = e.target.files?.[0];
        e.target.value = "";
        if (!file) return;

        setCargandoAdjunto(true);
        setErrorAdjunto("");
        const data = new FormData();
        data.append("uid", datos.uuid_comprobante);
        data.append("archivo", file);

        try {
            const res = await fetch(UrlApi + "/uploadfiles/uploadfiles", {
                method: "POST",
                body: data,
            });
            const body = await res.json().catch(() => ({}));
            if (!res.ok) {
                throw new Error(body?.message || "No se pudo cargar el archivo");
            }
            setNotificacion({
                open: true,
                mensaje: body?.message || "Archivo cargado",
                severity: "success",
                color: "",
            });
            getArchivos();
        } catch (err) {
            setErrorAdjunto(err.message || "No se pudo cargar el archivo");
        } finally {
            setCargandoAdjunto(false);
        }
    };

    const quitarArchivo = async (archivo) => {
        if (!window.confirm("Usted está por eliminar el archivo: " + archivo.nombre)) return;

        try {
            const res = await fetch(UrlApi + "/uploadfiles/todownload/" + archivo.id, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
            });
            if (!res.ok) {
                setErrorAdjunto("No se borro el archivo");
                return;
            }
            setErrorAdjunto("");
            setNotificacion({
                open: true,
                mensaje: "Archivo borrado",
                severity: "success",
                color: "",
            });
            getArchivos();
        } catch (err) {
            setErrorAdjunto("No se borro el archivo");
        }
    };

    useEffect(() => {
        // Solo si existe el uuid_comprobante disparamos las peticiones
        if (datos.uuid_comprobante) {

            // Ejecutamos ambas
            ApiServices.getDatosCuerpo(datos.uuid_comprobante, setdatosCuerpo);
            ApiServices.getDatosImpuestos(datos.uuid_comprobante, setDatosImpuestos);
            ApiServices.getDatosPie(datos.uuid_comprobante, setdatosPie);
        }
    }, [datos.uuid_comprobante]); // Se dispara cuando el UUID esté disponible


    useEffect(() => {
        const cargarCoincidencias = async () => {
            //obtengo la lista de comprobantes
            ApiServices.getComprobantes((lista) => {
                settiposComprobantes(lista); // y los guardo aca 

                // una vez que obtengo todos los comprobantes comparo con el que ya vienen de datos.
                if (datos.id_tipocomprobante) {
                    const coincide = lista.find(t => t.id_tipo_comprobante === Number(datos.id_tipocomprobante));
                    if (coincide) {
                        setcomprobanteSelected(coincide);
                    }
                }
            });
        };

        cargarCoincidencias();
    }, [datos.id_tipocomprobante]);

    useEffect(() => {
        if (comprobanteSelected) {
            const nuevoIva = comprobanteSelected.id_tipo_comprobante === 11 ? 4 : 1;

            setdatosCuerpo((prevDatos) =>
                prevDatos.map((item) => ({
                    ...item,
                    id_porcentajeiva: nuevoIva,
                }))
            );
        }
    }, [comprobanteSelected]);

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#1f618d",
            },
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "#1f618d",
        },
    };

    useEffect(() => {
        if (datos.total !== undefined && datos.total !== null) {
            // 1. El valor real para cálculos (float)
            setTotal(parseFloat(datos.total));

            // 2. El valor para la vista (string formateado)
            // Convertimos el punto decimal del back a coma para que formatNumber lo entienda
            const totalString = datos.total.toString().replace(".", ",");
            setTotalMuestro(formatNumber(totalString));
        }
    }, [datos.total]);

    useEffect(() => {
        if (proveedorSelected && proveedorSelected.id) {

            ApiServices.getImputacionProveedor(
                proveedorSelected.id,
                setimputacionProveedor
            );
        } else {
            // Si no hay proveedor, limpiamos las imputaciones sugeridas
            setimputacionProveedor([]);
        }
    }, [proveedorSelected]);

    const propiedades = {
        datos: datos,
        setDatos: setDatos,
        tiposComprobantes: tiposComprobantes,
        settiposComprobantes: settiposComprobantes,
        impuestos: impuestos,
        proveedores: proveedores,
        setProveedores: setProveedores,
        setLoading: setLoading,
        imputaciones: imputaciones,
        imputacionesProveedor: imputacionesProveedor,
        setimputacionProveedor: setimputacionProveedor,
        sucursales: sucursales,
        condicionesPago: condicionesPago,
        valorPorcentajes: valorPorcentajes,
        tipoMoneda: tipoMoneda,
        proveedorSelected: proveedorSelected,
        setproveedorSelected: setproveedorSelected,
        guardarImputacProveedor: guardarImputacProveedor,
        setGuardarImputacProveedor: setGuardarImputacProveedor,
        total: total,
        setTotal: setTotal,
        ocsSelected: ocsSelected,
        setOcsSelected: setOcsSelected,
        totalMuestro: totalMuestro,
        setTotalMuestro: setTotalMuestro,
        calcularSubtotalIva: calcularSubtotalIva,
        setCalcularSubtotalIva: setCalcularSubtotalIva,
        neto: neto,
        setnetoGravado: setnetoGravado,
        comprobanteExiste: comprobanteExiste,
        setcomprobanteExiste: setcomprobanteExiste,
        saldonoaplic: saldonoaplic,
        setsaldonoaplic: setsaldonoaplic,
        montoMaximoSinOC: montoMaximoSinOC,
        setMontoMaximoSinOC: setMontoMaximoSinOC,
        showAddProveedor: showAddProveedor,
        setShowAddProveedor: setShowAddProveedor,
        muestroDiferencia: muestroDiferencia,
        setmuestroDiferencia: setmuestroDiferencia,
        showInfoDialog: showInfoDialog,
        setShowInfoDialog: setShowInfoDialog,
        loading: loading,
        setLoading: setLoading,
        datosCuerpo: datosCuerpo,
        setdatosCuerpo: setdatosCuerpo,
        datosPie: datosPie,
        setdatosPie: setdatosPie,
        style: style,
        comprobanteSelected: comprobanteSelected,
        setcomprobanteSelected: setcomprobanteSelected,
        handleOnChangeTotal: handleOnChangeTotal,
        setotrosTributos: setotrosTributos,
        setImputaciones: setImputaciones,
        datosImpuestos: datosImpuestos,
        setDatosImpuestos: setDatosImpuestos,
        handleAddProveedor: handleAddProveedor,
        saldoNegativo: saldoNegativo,
        setSaldoNegativo: setSaldoNegativo,
        bancos: bancos,
    };

    const limpiarNumero = (valor) => {
        if (!valor) return 0;

        const numerico = String(valor)
            .replace(/\./g, "")
            .replace(",", ".");

        return parseFloat(numerico) || 0;
    };

    const formatoCalculo = (valor) => {
        // Si valor es null o undefined, devolvemos 0
        if (valor === null || valor === undefined) return 0;

        // Lo convertimos a String por si viene como número
        let valorStr = String(valor);

        // Ahora sí podemos hacer el replace sin miedo
        return parseFloat(valorStr.replace(/\./g, "").replace(/,/g, "."));
    };

    console.log("datosCuerpo,", datosCuerpo);
    

    async function handleSubmit(e) {
        e.preventDefault();
        // if (!validarFormulario()) return;
        // setdisbtn(true);

        if ((formatoCalculo(saldonoaplic) > 1) || saldoNegativo) {
            alert(formatoCalculo(saldonoaplic) > 1 ? "Hay saldo sin aplicar" : "Hay saldo negativo.")
            setdisbtn(false)
            return;
        }

        const esCredito = comprobanteSelected && (comprobanteSelected.c_credito === -1 || comprobanteSelected.id_tipo_comprobante === 3); // Ajustar según tus IDs
        const factor = esCredito ? -1 : 1;
        const netoLimpio = limpiarNumero(neto);
        const otrosTrib = limpiarNumero(otrostributos);
        let adjustedTotal = total * (esCredito ? -1 : 1);

        const cuerpo = datosCuerpo.map((item) => ({
            id: item.id || null, // Importante para editar líneas existentes
            subtotal: formatoCalculo(item.subtotal) * factor,
            id_porcentajeiva: item.id_porcentajeiva,
            monto_iva: limpiarNumero(item.monto_iva) * factor,
            id_imputacion: item.id_imputacion,
            detalle_productos: item.detalle_productos,
            uuid_comprobante: datos.uuid_comprobante, // El uuid que viene de la cabecera original
            usuario: localStorage.getItem("user"),
        }));

        // 3. Mapeamos los Impuestos - Ahora usamos el array datosImpuestos
        const impuestos = datosImpuestos
            .filter((item) => !!item.id_impuesto && formatoCalculo(item.importe) > 0)
            .map((item) => ({
                id: item.id || null,
                id_impuesto: item.id_impuesto,
                detalle: item.detalle || "",
                importe: formatoCalculo(item.importe) * factor,
                uuid_comprobante: datos.uuid_comprobante,
                usuario: localStorage.getItem("user"),
            }));

        const esBanco = esComprobanteBanco(comprobanteSelected);

        const cabecera = {
            cuit_proveedor: proveedorSelected.cuit,
            id_tipocomprobante: comprobanteSelected.id || comprobanteSelected.id_tipo_comprobante,
            id_condicionpago: datos.id_condicionpago,
            id_proveedor: proveedorSelected.id, // Aseguramos que el ID del proveedor vaya en la cabecera
            id_sucursal: datos.id_sucursal,
            nro_comprobante: armarNroComprobante(comprobanteSelected, datos),
            fecha_factura: datos.fecha_factura,
            vto_factura: moment(datos.vto_factura).format("YYYY-MM-DD"),
            observaciones: datos.observaciones,
            id_tipomoneda: datos.id_tipomoneda,
            tipo_cambio: datos.tipo_cambio,
            total: adjustedTotal,
            uuid_comprobante: datos.uuid_comprobante,
            id_estado: 136,
            usuario: localStorage.getItem("user"),
            id_empresa: datos.id_empresa,
            neto_gravado: neto * (esCredito ? -1 : 1),
            otros_tributos: otrostributos * (esCredito ? -1 : 1),
            ...(esBanco && {
                id_banco: datos.id_banco,
                concepto: datos.concepto,
            }),
        };

        const pie = datosPie.map((item, index) => {
            return {
                uuid_comprobante: datos.uuid_comprobante,
                id_porcentajeiva: item.id_porcentajeiva,
                importe: item.importe * (esCredito ? -1 : 1), // Total de la línea (Neto + IVA)
                usuario: localStorage.getItem("user"),
            };
        });

        const listaImputaciones = [...new Set(datosCuerpo.map(i => i.id_imputacion).filter(id => id))];

        const requestData = {
            // ocsSelected: total > montoMaximoSinOC.valor ? ocsSelected : [],
            uuid: cabecera.uuid_comprobante,
            datosCabecera: cabecera,
            datosCuerpo: cuerpo,
            datosImpuestos: impuestos,
            datosPie: pie,
            guardarImputacionEnProveedor: guardarImputacProveedor,
            listaImputacionesAAsociar: listaImputaciones, // <--- ENVIAMOS LA LISTA AL BACKEND

            ...(proveedorSelected?.padron === 1 && {
                nuevoProveedor: {
                    ...proveedorSelected,
                    id_condicionventa: cabecera.id_condicionpago,
                    usuario: localStorage.getItem("user"),
                    observaciones: "Proveedor cargado en carga de comprobantes.",
                },
            }),
        };
        try {
            console.log("requestData", requestData)

                const res = await fetch(`${UrlApi}/comprobantes_cabecera/editar_comprobante`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestData),
                });

                if (res.ok) {
                     props.setOpen(false)
                        props.tabla(true)
                }
        } catch (error) {
            console.error("Error al editar:", error);

        }
    }

    return (
        <div style={{
            minHeight: "90vh",
        }}>
            <Container maxWidth="xl" sx={{ pt: 1, pb: 10 }}>
                <Title title={`Editar comprobante ${datos.nro_comprobante}`}
                    handleClose={() => {
                        props.setOpen(false)
                        props.tabla(true)
                    }} />

                <FormComprobanteEditar
                    {...propiedades}
                    getProveedores={ApiServices.getProveedores} />
                {
                    showAddProveedor && (
                        <DialogoNuevoProveedor
                            open={showAddProveedor}
                            handleCloseAddProveedor={handleCloseAddProveedor}
                        />)
                }

                <Paper
                    elevation={3}
                    sx={{
                        px: 2,
                        py: 1.5,
                        mt: 1,
                        borderRadius: 3,
                    }}
                >
                    <Box sx={{ width: "100%" }}>
                        <Stack spacing={1}>
                            {archivos.map((archivo) => (
                                <AdjuntoFileCard
                                    key={archivo.id}
                                    title="Comprobante"
                                    idTipoAdjunto={archivo.id}
                                    hasFile
                                    fileName={archivo.nombre}
                                    showDownloadAction
                                    showViewAction
                                    onFileChange={() => {}}
                                    onRemove={() => quitarArchivo(archivo)}
                                    onView={() =>
                                        ViewUploadFile(
                                            `${archivo.id_archivo}-${archivo.nombre}`,
                                            archivo.extension
                                        )
                                    }
                                    onDownload={() =>
                                        DownloadFiles(`${archivo.id_archivo}-${archivo.nombre}`)
                                    }
                                />
                            ))}
                            <AdjuntoField
                                title="Adjuntar comprobante"
                                idTipoAdjunto={0}
                                loadingId={cargandoAdjunto ? 0 : null}
                                hasFile={false}
                                accept="*/*"
                                error={errorAdjunto}
                                cardProps={{
                                    showRemoveAction: false,
                                    showDownloadAction: false,
                                }}
                                onFileChange={handleAdjuntoChange}
                                onRemove={() => {}}
                            />
                        </Stack>
                    </Box>
                </Paper>
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1.5, mb: 2 }}>
                    <Button
                        variant="contained"
                        type="submit"
                        disabled={disbtn}
                        onClick={handleSubmit}
                        startIcon={<Save />}
                        sx={{
                            backgroundColor: "#1f618d",
                            "&:hover": { backgroundColor: "#154360" },
                        }}
                    >
                        Guardar Comprobante
                    </Button>
                </Box>
            </Container>
        </div>
    )
}